import React from "react";
import { Link } from "react-router-dom";
import PublicNav from "@/components/n360/PublicNav";

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="n360-app-bg n360-grain min-h-screen flex flex-col">
      <PublicNav />
      <div className="flex-1 grid place-items-center px-5 py-14">
        <div className="w-full max-w-md relative z-10">
          <div className="text-center mb-8 rise">
            <div className="font-mono-i text-[11px] tracking-[0.3em] text-[#F1551D]/90 uppercase mb-3">Secure Member Portal</div>
            <h1 className="font-display text-3xl text-[#0D3C4C] mb-2">{title}</h1>
            <p className="text-sm text-[#5f7d86]">{subtitle}</p>
          </div>
          <div className="n360-card p-7 rise">{children}</div>
          {footer && <div className="text-center mt-6 text-sm text-[#5f7d86]">{footer}</div>}
          <div className="text-center mt-8">
            <Link to="/" className="text-xs text-[#8598a0] hover:text-[#F1551D]">← Return to public site</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block mb-4">
      <span className="block text-xs uppercase tracking-wider text-[#5f7d86] mb-1.5">{label}</span>
      {children}
    </label>
  );
}

export const inputCls =
  "w-full px-4 py-2.5 rounded-lg bg-[#F6EEDC] border border-[#F1551D]/20 text-[#0D3C4C] placeholder:text-[#aab9bd] focus:outline-none focus:border-[#F1551D]/60 transition-colors";
